import { useContext } from 'react';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';
import { getAppId, getSkippers } from '../utils/helpers';

const useCxtPropsAndOptions = (anchorId, requestKey, schemaName, maxResults, serviceType) => {
  const { channel, isServer, isConsumerApp } = useContext(ExperienceContext);
  const { storeId, storeZip: zipCode, isLocalized } = useStore();

  return {
    isMobile: channel === 'mobile',
    isServer,
    opts: {
      variables: {
        anchorId,
        appId: getAppId(channel, isConsumerApp),
        apiName: schemaName,
        dataSource: schemaName,
        ...getSkippers({}),
        key: requestKey,
        maxResults,
        serviceType,
        storeId,
        zipCode
      },

      ssr: false,
      skip: !isLocalized,
    }
  };
};
export default useCxtPropsAndOptions;